import axios from 'axios';

export const agpAxiosClient = axios.create();
